export const getStatusColor = (status: string) => {
  if(!status || typeof status !== "string") return "gray"
  switch (status.toLowerCase()) {
    case "scheduled":
      return "blue";
    case "cancelled":
      return "red";
    case "checked out":
      return "cyan";
    case "confirmed":
    case "completed":
      return "green";
    case "checked in":
      return "yellow";
    case "1":
      return "green";
    case "0":
      return "red";
    default:
      return "gray";
  }
};


export const getStatusColorAndBg = (status: string) => {
  if(!status) return { color: "gray", bg: "gray.50" }
 
  const statusStr = String(status).toLowerCase();
 
  switch (statusStr) {
    case "completed":
    case "confirmed":
    case "1":  
    case "active":
      return { color: "green", bg: "green.50" };
    case "scheduled":
      return { color: "blue", bg: "blue.50" };
    case "cancelled":
      return { color: "red", bg: "red.50" };
    case "checked in":
      return { color: "yellow", bg: "yellow.50" };
    case "checked out":
      return { color: "cyan", bg: "cyan.50" };
    case "expired":
      return { color: "red", bg: "red.50" };
    case "good":
      return { color: "green", bg: "green.50" };
    case "need to replenish":
      return { color: "yellow", bg: "yellow.50" };
    default:
      return { color: "gray", bg: "gray.50" };
     


  }
};